import { render, staticRenderFns } from "./ShippingRates.vue?vue&type=template&id=0a959a22&"
import script from "./ShippingRates.vue?vue&type=script&lang=ts&"
export * from "./ShippingRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports